import { render, staticRenderFns } from "./AutoResponseModal.vue?vue&type=template&id=32afff7e&"
import script from "./AutoResponseModal.vue?vue&type=script&lang=js&"
export * from "./AutoResponseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports